import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowLeft } from '@fortawesome/pro-regular-svg-icons/faLongArrowLeft'
import { reverse } from 'src/routes/config'
import useBreadcrumbs from 'src/hooks/useBreadcrumbs'

import styles from './goBackArrow.module.scss'

GoBackArrow.propTypes = {
    history: PropTypes.object.isRequired,
}

let prevLocation = ''
let prevSearch = ''
function GoBackArrow({ history, onClickCallback, goToBreadcrumb = false }) {
    const { previousBreadcrumb } = useBreadcrumbs()

    useEffect(() => {
        return history.listen(location => {
            prevLocation = location.pathname
            prevSearch = location.search
        })
    }, [history])

    const onClick = e => {
        if (onClickCallback) {
            onClickCallback(e)
        }
        if (!!prevLocation.length && !goToBreadcrumb) {
            history.goBack()
        } else if (previousBreadcrumb.linkName) {
            history.push(
                reverse(`${previousBreadcrumb.linkName}`, {
                    search: prevSearch,
                })
            )
        } else {
            history.push(reverse('dashboard'))
        }
    }

    return (
        <button className={styles.goBack} onClick={onClick}>
            <FontAwesomeIcon icon={faLongArrowLeft} />
        </button>
    )
}

export default GoBackArrow
